import React, { useState, useEffect, useRef, useContext } from "react";
import "./Actiondropdown.scss";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { SlArrowDown } from "react-icons/sl";

import { Tooltip } from "antd";
import { SlArrowUp } from "react-icons/sl";
const Actiondropdown = ({ model, setModel }) => {
  const Apiurl = process.env.REACT_APP_API_KEY;
  const [loader, setLoader] = useState(false);
  const [isDropdownVisible, setDropdownVisibility] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState("");
  // const apiUrl = "http://localhost:3333"
  const dropdownRef = useRef(null);
  const [show, setShow] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [models, setModels] = useState([]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleOptionClick = (value) => {
    setModel(value);
    closeDropdown(); // Assuming you want to close the dropdown after selecting an option
  };
  const toggleDropdown = () => {
    setDropdownVisibility(!isDropdownVisible);
    if (!isDropdownVisible) {
      getModels();
    }
  };
  const closeDropdown = () => {
    setDropdownVisibility(false);
  };
  const handleThemeSelect = (theme) => {
    setSelectedTheme(theme);
    closeDropdown();
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      closeDropdown();
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const navigate = useNavigate();
  const getModels = () => {
    setLoader(true);
    const logintoken = localStorage.getItem("authToken");
    axios
      .get(`${Apiurl}/api/text-models`, {
        headers: {
          "x-access-token": logintoken,
        },
      })
      .then((res) => {
        setModels(res.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  return (
    <>
      <div className="actionDropdown">
        <div className="actionDropdown-first">
          <div className="inputbox" onClick={toggleDropdown} ref={dropdownRef}>
            <div className="leftside">
              {" "}
              <Tooltip title={model}>{model}</Tooltip>
            </div>
            <div className="rightside">
              {isDropdownVisible ? (
                <SlArrowUp
                  color="#64748B"
                  width="14"
                  height="7"
                  strokeWidth="2.5px"
                />
              ) : (
                <SlArrowDown
                  color="#64748B"
                  width="14"
                  height="7"
                  rotate={2}
                  strokeWidth="2.5px"
                />
              )}
            </div>
            {isDropdownVisible && (
              <div
                className="actionDropdown customscrollbar"
                onClick={closeDropdown}
              >
                {loader ? (
                  <div class="customloading">
                    <div className="loading"></div>
                  </div>
                ) : (
                  models.map((item) => (
                    <div
                      className="firstdropdown"
                      onClick={() => handleOptionClick(item.id)}
                    >
                      <span value={item.id}>{item.id}</span>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Actiondropdown;
